/**
 * Enum for input field types
 */
export enum InputFieldType {
  Text = 'text',
  Password = 'password',
  Number = 'number',
  Button = 'button',
  Checkbox = 'checkbox',
  Color = 'color',
  Date = 'date',
  Datetimelocal = 'datetimelocal',
  Email = 'email',
  File = 'file',
  Hidden = 'hidden',
  Image = 'image',
  Month = 'month',
  Radio = 'radio',
  Range = 'range',
  Reset = 'reset',
  Search = 'search',
  Submit = 'submit',
  Tel = 'tel',
  Time = 'time',
  Url = 'url',
  Week = 'week',
}

